<template>
  <div class="content flex-box" v-if="activity">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-receptionist"
      entity-name="接待人员"
      add-btn="添加"
      hide-show-detail
      :hide-action="!editable"
      :before-update="beforeUpdate"
      :custom-url="customUrl"
      :query="query"
      :action="action"
      :columns="columns"
      :rules="rules">
      <template v-slot:button v-if="editable">
        <a-button @click="importReceptionist"><a-icon type="upload" />批量导入</a-button>
      </template>
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input v-model="form.keyword" placeholder="输入姓名或手机号码查询"></a-input>
        </a-form-model-item>
      </template>
      <template v-slot:edit="{form}">
        <a-form-model-item label="姓名" prop="name">
          <a-input v-model="form.name" placeholder="请输入接待人员姓名"></a-input>
        </a-form-model-item>
        <a-form-model-item label="手机号码" prop="tel">
          <a-input v-model="form.tel" placeholder="请输入接待人员手机号码"></a-input>
        </a-form-model-item>
      </template>
    </data-list>
    <batch-import-modal
      v-model="visible"
      name="接待人员导入模板.xlsx"
      url="https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/assets/activity/template/receptionist_template.xlsx "
      import-url="/activity/activity-receptionist/recept-import"
      :activity="activity.id * 1"
      @import="handleImport"></batch-import-modal>
  </div>
</template>

<script>
    import batchImportModal from "../../components/batch-import-modal";
    import mixins from "./mixins";
    export default {
        name: "ActivityReceptionist",
        components: {
            batchImportModal
        },
        data() {
            return {
                columns: [
                    {title: '姓名', dataIndex: 'name'},
                    {title: '手机号码', dataIndex: 'tel'},
                ],
                rules: {
                    name: [{ required: true, message: '请输入工作人员姓名', trigger: 'blur' }],
                    tel: [
                        { required: true, message: '请输入工作人员手机号码', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ]
                },
                visible: false,
                moduleKey: 'receptionist',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '&filter[type]=3';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        methods: {
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.activity_id = this.activity.id;
                    form.type = 3;
                }
                fn();
            },
            customUrl(form) {
                let res = '';
                if(form.keyword) {
                    res = `&filter[or][0][name][like]=${form.keyword}&filter[or][1][tel][like]=${form.keyword}`;
                }
                return res;
            },
            importReceptionist() {
                this.visible = true;
            },
            handleImport() {
                this.visible = false;
                this.$refs.dataList.getList();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
